<div class="approval-emails">
  <div class="approval-emails__header">
    <h4>Approval Emails</h4>
    <button *ngIf="!isEditing" class="edit-btn" (click)="isEditing = true">
      <i class="pi pi-pencil"></i> Edit
    </button>
  </div>

  <div class="approval-emails__list" *ngIf="!isEditing">
    <div *ngIf="emails.length === 0" class="empty-state">No approval emails configured</div>
    <div *ngFor="let email of emails" class="email-chip">
      <i class="pi pi-envelope"></i>
      <span>{{ email }}</span>
    </div>
  </div>

  <div class="approval-emails__edit" *ngIf="isEditing">
    <div class="email-tags">
      <div *ngFor="let email of emails; let i = index" class="email-tag">
        <span>{{ email }}</span>
        <i class="pi pi-times remove-btn" (click)="removeEmail(i)"></i>
      </div>
    </div>
    <div class="add-row">
      <input
        type="email"
        [(ngModel)]="newEmail"
        placeholder="Enter email address"
        class="email-input"
        (keydown.enter)="addEmail()"
      />
      <button class="add-btn" (click)="addEmail()" [disabled]="!newEmail.trim()">
        <i class="pi pi-plus"></i> Add
      </button>
    </div>
    <div class="action-row">
      <button class="cancel-btn" (click)="cancel()">Cancel</button>
      <button class="save-btn" (click)="save()" [disabled]="isSaving">
        Save
        <i *ngIf="isSaving" class="pi pi-spin pi-spinner"></i>
      </button>
    </div>
  </div>
</div>
